define('RunOnEveryPage/components/dummyComponent',[
],
function () {

    function init() {
        //console.log('This is just a dummy component initializing and proving that RequireJS bundling worked. Please delete this at some point.')
    }

    return {
        init: init
    };

});

